import React from 'react';
import { ClockIcon, FilesIcon, PencilLineIcon, RepeatIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { painPoints } from '../../data/content';
const icons = [ClockIcon, PencilLineIcon, RepeatIcon, FilesIcon];
export function PainSection() {
  return <section aria-labelledby="pain-heading" className="bg-brand-oatmeal px-5 py-16 lg:px-8 lg:py-24" data-id="element-145" data-mp="3m15n1syyx4mo">
      <div className="mx-auto max-w-5xl" data-id="element-146" data-mp="nj9vk3ubltza">
        <SectionHeading id="pain-heading" title={<>
              Love Teaching Hair Extensions… But <Accent data-id="element-148" data-mp="dt75abel2u4n">Hate Preparing Everything?</Accent>
            </>} body="You're an extension professional. You know the techniques. But preparing an entire class is a different kind of work." data-id="element-147" data-mp="ni8i5spu0vee" />

        <ul className="mt-12 grid gap-4 sm:grid-cols-2" role="list" data-id="element-149" data-mp="16a1f1y80v0re">
          {painPoints.map((pain, index) => {
          const Icon = icons[index];
          return <li key={pain.title} className="flex items-start gap-4 rounded-[20px] bg-brand-ivory p-6 shadow-[0_20px_40px_-34px_rgba(24,45,42,0.45)]" data-id="element-150" data-mp="3bd9a3lxwg7io" data-mpi={index}>
                <span className="flex h-11 w-11 flex-none items-center justify-center rounded-full bg-brand-blush" data-id="element-151" data-mp="31ng0url8c4hl">
                  <Icon className="h-5 w-5 text-brand-gold-dark" strokeWidth={1.5} aria-hidden="true" data-id="element-152" data-mp="36lzmsrztpg9y" />
                </span>
                <span data-id="element-153" data-mp="2slyp1leuuoyp">
                  <span className="block font-display text-[1.35rem] font-bold leading-tight text-brand-charcoal" data-id="element-154" data-mp="2slgjfy6ayye4">
                    {pain.title}
                  </span>
                  <span className="mt-1.5 block text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-155" data-mp="2ipvnagnx0sca">{pain.text}</span>
                </span>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-12 max-w-2xl text-center font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-156" data-mp="gy8ty8gjwlcn">
          Your expertise should be spent <Accent data-id="element-157" data-mp="kfo663e2ly6a">teaching</Accent> — not constantly rebuilding your classroom
          materials.
        </p>
      </div>
    </section>;
}